import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logos/Sync_app.png'


const _withScopeId = n => (_pushScopeId("data-v-37609427"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sync-app-tile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Tree Crossing Sync"),
  /*#__PURE__*/_createElementVNode("div", { class: "tagline" }, " Easily upload your family tree with all your photos and documents. ")
], -1))
const _hoisted_4 = ["href"]

import { computed, onMounted, ref } from 'vue'
import { currentOS, osInfos } from '@/rd/ResearchDataModel'
import { getSyncAppInfoAsync, SyncAppInfo } from './SyncAppInfo'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncAppTile',
  setup(__props) {

const loadingRef = ref(false)
const syncAppInfoRef = ref<SyncAppInfo>()

const osInfoRef = computed(() => osInfos.find(os => os.id == currentOS))
const appUrlRef = computed(() => {
  if (currentOS == 'windows') {
    return syncAppInfoRef.value?.storeUrls.windows
  }
  if (currentOS == 'mac') {
    return syncAppInfoRef.value?.downloadUrls.mac
  }
  return undefined
})

onMounted(async () => {
  loadingRef.value = true
  try {
    syncAppInfoRef.value = await getSyncAppInfoAsync()
  }
  finally {
    loadingRef.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (!loadingRef.value && appUrlRef.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: appUrlRef.value,
          class: "btn btn-primary get-btn"
        }, " Get for " + _toDisplayString(osInfoRef.value?.name), 9, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})